import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Diversity3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"diversity_3"}/>
}
